
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.3 46.8l-8.7-9.7h4.9v-8.3h7.7v8.3h4.9l-8.8 9.7z"}}),_c('path',{attrs:{"d":"M31.9 34.5v-8.3h9.6v-22h-35v42.6h28.4l-7.2-8-3.9-4.3h8.1zm-19-22.8h21.9v2.5H12.9v-2.5zm0 5.4h21.9v2.5H12.9v-2.5zm0 14.2h6.3v2.5h-6.3v-2.5zm8.3 8h-8.4v-2.5h8.4v2.5zm7-11H12.9v-2.5h15.4v2.5z"}})])
          )
        }
      }
    